import { render, staticRenderFns } from "./storeData2.vue?vue&type=template&id=7e99ba2a&"
import script from "./storeData2.vue?vue&type=script&lang=js&"
export * from "./storeData2.vue?vue&type=script&lang=js&"
import style0 from "./storeData2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports